// 将不是子节点的 过滤出去(el-tree 展示用)
import axios from 'axios'
import {Notification} from 'element-ui'
import store from '../store'

export function filterTree2Leaf (nodeArr, treeData) {
  let head
  // 如果树 的数据是一个数组，取第一个元素
  if (treeData instanceof Array) {
    head = treeData[0]
  } else {
    head = treeData
  }
  // 获取到完整树的所有叶子节点
  let allLeaf = []
  // 定义函数   获取到完整树的所有叶子节点
  function getAllLeaf (leafArr, treeData) {
    for (let i = 0; i < treeData.length; i++) {
      let thisTreeData = treeData[i]
      if (thisTreeData.children === undefined || thisTreeData.children == null || !(thisTreeData.children instanceof Array) || thisTreeData.children.length < 1) {
        leafArr.push(thisTreeData.id)
      } else {
        getAllLeaf(leafArr, thisTreeData.children)
      }
    }
  }
  // 运行函数   获取到完整树的所有叶子节点
  getAllLeaf(allLeaf, [head])
  // 过滤掉后台传过来的选中树数据 ，去除非叶子节点
  for (let i = 0; i < nodeArr.length;) {
    if (allLeaf.indexOf(nodeArr[i]) < 0) {
      nodeArr.splice(i, 1)
    } else {
      i++
    }
  }
}
export function getMessage (code, message) {
  let retMsg = ''
  if (message) {
    let num = 1
    for (let key in message) {
      retMsg += num + ',' + message[key] + ' '
      num++
    }
  }
  return retMsg
}
export function exportSimple (url, fileName) {
  axios({
    url: url,
    method: 'get',
    responseType: 'blob',
    withCredentials: true
  }).then(response => {
    const blob = new Blob([response.data])
    if ('download' in document.createElement('a')) { // 非IE下载
      const elink = document.createElement('a')
      fileName = decodeURI(fileName)
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else { // IE10+下载
      navigator.msSaveBlob(blob)
    }
  }).catch(ex => {
    Notification.error({ title: '系统异常', message: '导出文件异常!' })
  })
}
const permissions = store.state.user
export function validateAuthority (property) {
  const routerSystemKey = permissions.clickMenu
  const ps = permissions.currentLoginDepartment.departmentSystemAuths.filter(m => m.authKey === routerSystemKey)[0].authResourceKeys
  if (ps !== undefined && ps.indexOf(property) >= 0) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/commonUtils.js